import React from 'react';
import { Col, EditableInfoComponent, Row } from 'components';
import { SpecialPricingRulesIcon } from 'components/common/icons';
import { SpecialPricingRulesAddUpdateModal } from 'feature/clientTabs/payments/specialPricingRules/addEdit';
import { DeleteModal } from 'feature/clientTabs/payments/specialPricingRules/delete';
import { SpecialPricingRule } from 'feature/clientTabs/payments/specialPricingRules/specialPricingRule';
import { useSpecialPricingRules } from 'feature/clientTabs/payments/specialPricingRules/useSpecialPricingRules';
import { useAccessControl } from 'components/common/accessControl/useAccessControl';
import { PERMISSIONS } from 'constants/permissions';

export const SpecialPricingRules = React.memo(() => {
  const { hasAccess } = useAccessControl();
  const {
    addModalState,
    onAddModalStateChange,
    pricingRules,
    specialPricingRuleId,
    onDeleteModalClose,
    onDeleteModalOpen,
  } = useSpecialPricingRules();
  return (
    <>
      <EditableInfoComponent
        title={'Special Pricing Rules'}
        icon={<SpecialPricingRulesIcon />}
        creatable={hasAccess(PERMISSIONS.clients.payment_special_pricing_rules.write)}
        editable={false}
        onAdd={onAddModalStateChange}
      />
      <Row>
        {pricingRules.map((_pricingRule: Record<string, any>) => (
          <Col key={_pricingRule.id} span={24}>
            <SpecialPricingRule data={_pricingRule} onDeleteModalOpen={onDeleteModalOpen} />
          </Col>
        ))}
      </Row>
      <SpecialPricingRulesAddUpdateModal modalState={addModalState} onModalStateChange={onAddModalStateChange} />
      <DeleteModal
        dataToDelete={{ id: specialPricingRuleId }}
        openModal={!!specialPricingRuleId}
        onDeleteModalClose={onDeleteModalClose}
      />
    </>
  );
});
